import { ReactNode, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useLayoutPreferences } from '../context/LayoutPreferencesContext';
import { buildTheme } from './theme';

// Applique le thème global ; la couleur principale suit la couleur d'accent des préférences d'affichage
function AppThemeProvider({ children }: { children: ReactNode }) {
  const { sidebarColor } = useLayoutPreferences();
  const theme = useMemo(() => buildTheme(sidebarColor), [sidebarColor]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default AppThemeProvider;
